import React, { useContext, useEffect, useState } from 'react';

import uuid from 'react-uuid';

import { ContextSolicitacoes } from '../../../../services/solicitacoes';

import { Spinner } from '../../../StyledComponent';

import EntendiConcordo from '../../EntendiConcordo';

import {
  ContainerEditarSolicitacao,
  HeaderEditarSolicitacao,
  AdicionarNovoReparo,
} from './styles';

import { ContextSindico } from '../../../../services/sindico';

import AddReparoPopup from '../../AddReparoPopup';

import MessagePopUp from '../../../MessagePopup';

import { ButtonPrimary } from '../../../StyledComponent';

const EditarSolicitacao = ({
  tema,
  editarSolicitacao,
  reparos,
  setReparos,
  apontamentoSelecionado,
  setApontamentoSelecionado,
  setSalvarAlteracoes,
  novoAgendamento,
  salvarAlteracoes,
  children,
  isSindico,
  setEntendiConcordo,
  entendiConcordo,
  loadingTentativaAgendamento,
  savingChanges,
  showAddReparoPopup,
  setShowAddReparoPopup,
}) => {
  const [validWarranty, setValidWarranty] = useState(false);
  const {
    loadImoveisDisponiveis,
    loadingImoveis,
    listaDeImoveis,
    apontamentos,
    loadApontamentos,
    setApontamentos,
    listaApontamentosOriginal,
    imovelSolicitacao,
    empreendimentoSelecionado,
  } = useContext(isSindico ? ContextSindico : ContextSolicitacoes);

  const [descricao, setDescricao] = useState('');

  const [documents, setDocuments] = useState([]);

  const [showSuccessAddReparoPopup, setShowSuccessAddReparoPopup] =
    useState(false);

  useEffect(() => {
    if (editarSolicitacao) {
      loadImoveisDisponiveis();
      loadApontamentos(reparos);
    } else if (novoAgendamento) {
      loadImoveisDisponiveis();
      loadApontamentos();
    }
  }, [editarSolicitacao, novoAgendamento]);

  const verificaSeDisabilitado =
    !apontamentoSelecionado ||
    !descricao ||
    apontamentoSelecionado ===
      `Selecione uma categoria de apontamento que melhor descreva o seu reparo.`;

  const handleAddReparo = () => {
    setShowAddReparoPopup(false);
    setValidWarranty(undefined);
    setApontamentos(
      apontamentos.filter((item) => item.nome != apontamentoSelecionado)
    );

    setValidWarranty(undefined);

    if (!novoAgendamento && !salvarAlteracoes) setSalvarAlteracoes(true);

    setApontamentoSelecionado(
      'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
    );
    setDescricao('');

    let temp = listaApontamentosOriginal.find(
      (reparo) => reparo.Descricao === apontamentoSelecionado
    );

    setReparos([
      ...reparos,
      {
        ...temp,
        idSelecaoReparo: uuid(),
        description: descricao,
        workTypeId: temp.ApontamentoMotivos[0].IdSalesForce,
        documents: documents,
      },
    ]);

    setDocuments([]);
    setShowSuccessAddReparoPopup(true);
  };

  useEffect(() => {
    verificaGarantia();
  }, [apontamentoSelecionado]);

  const verificaGarantia = () => {
    let temp = listaApontamentosOriginal.find(
      (item) => item.Descricao === apontamentoSelecionado
    );
    if (temp) {
      // data de entrega do empreendimento
      const imovelSelecionado = listaDeImoveis.find(
        (imovel) =>
          imovel.nome === imovelSolicitacao || empreendimentoSelecionado
      );

      let deliveryDate = new Date(
        imovelSelecionado?.dataEntrega ||
          imovelSelecionado?.empreendimento?.DataEntrega
      );

      deliveryDate.setDate(
        deliveryDate.getDate() + temp.ApontamentoMotivos[0].PrazoDias
      );

      deliveryDate.setMinutes(new Date().getTimezoneOffset());

      // data de hoje
      let today = new Date();

      // data de entrega do imóvel
      let apartamentDeliveryDate = new Date(
        imovelSelecionado?.imovel?.EntregaChave
      );

      // +90 pois tudo tem garantia de 90 dias
      apartamentDeliveryDate.setDate(apartamentDeliveryDate.getDate() + 90);

      apartamentDeliveryDate.setMinutes(new Date().getTimezoneOffset());

      //verificar o caso de fazer agendamento no último dia da garantia  ***********************

      if (
        today.getTime() < deliveryDate.getTime() ||
        (!isSindico && today.getTime() < apartamentDeliveryDate.getTime())
      ) {
        setValidWarranty(true);
      } else setValidWarranty(false);
    }
  };

  if (loadingImoveis)
    return (
      <div style={{ width: '100%', margin: '4px 0' }} className='centralized'>
        <Spinner />
      </div>
    );

  let estiloCheckWarranty = tema.primaryColor;

  if (validWarranty === undefined) {
    estiloCheckWarranty = undefined;
  } else if (
    validWarranty &&
    apontamentoSelecionado !=
      'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
  ) {
    estiloCheckWarranty = tema.primaryColor;
  } else estiloCheckWarranty = tema.accent;

  // if (loadingApontamentos) return <p>loading...</p>;

  return (
    <div>
      <ContainerEditarSolicitacao tema={estiloCheckWarranty}>
        <HeaderEditarSolicitacao alertColor={estiloCheckWarranty}>
          <span
            style={{
              marginBottom: '20px',
              fontSize: 24,
              color: tema?.primaryColor,
            }}
          >
            Caso de reparo
          </span>
          <span
            style={{
              fontSize: 16,
              color: '#4d4d4d',
              fontWeight: 'normal',
              display: 'block',
              marginBottom: 40,
            }}
          >
            Aponte abaixo todos os pedidos que deseja fazer
          </span>

          {/* <IconContainer alertColor={estiloCheckWarranty} className='centralized'>
            <EditarSolicitacaoIcon />
          </IconContainer> */}
        </HeaderEditarSolicitacao>
        {children}
        {(!showAddReparoPopup || !reparos.length > 0) && (
          <AdicionarNovoReparo
            tema={tema.primaryColor}
            onClick={() => {
              setShowAddReparoPopup(true);
              setEntendiConcordo(false);
            }}
            disabled={savingChanges}
          >
            <div className='plusIcon'>
              <span>+</span>
            </div>
            <span className='title'>Adicionar novo reparo</span>
            <span className='subtitle'>
              Adicione todos os reparos que você deseja.
            </span>
          </AdicionarNovoReparo>
        )}
        {showAddReparoPopup && (
          <AddReparoPopup
            verificaSeDisabilitado={verificaSeDisabilitado}
            tema={tema}
            apontamentoSelecionado={apontamentoSelecionado}
            apontamentos={apontamentos}
            descricao={descricao}
            documents={documents}
            handleAddReparo={handleAddReparo}
            isSindico={isSindico}
            savingChanges={savingChanges}
            setApontamentoSelecionado={setApontamentoSelecionado}
            setShowAddReparoPopup={setShowAddReparoPopup}
            setDescricao={setDescricao}
            setDocuments={setDocuments}
            validWarranty={validWarranty}
            setValidWarranty={setValidWarranty}
          />
        )}
      </ContainerEditarSolicitacao>

      {reparos?.length > 0 && novoAgendamento && !showAddReparoPopup && (
        <EntendiConcordo
          setEntendiConcordo={setEntendiConcordo}
          entendiConcordo={entendiConcordo}
          loadingTentativaAgendamento={loadingTentativaAgendamento}
          savingChanges={savingChanges}
          isSindico={isSindico}
        />
      )}
      {showSuccessAddReparoPopup && (
        <MessagePopUp
          title={'Reparo adicionado'}
          message={'O reparo foi adicionado com sucesso!'}
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() => setShowSuccessAddReparoPopup(false)}
          >
            Confirmar
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </div>
  );
};

export default EditarSolicitacao;
